// Persistence for the "this is a developer instance" flag.
//
// Sugar is the master of the setting: inDeveloperMode() (yap-erp/include/utils.php) is
// published as FrontEndSugarConfig.dev and reported through the iframe message. That
// answer only arrives after the iframe has loaded, and react routes that are not the
// legacy iframe never get one at all, so the last known value is remembered and used
// until sugar says otherwise - otherwise the top bar would paint grey on every load and
// flip to red a second later.
//
// sessionStorage on purpose: the flag follows the tab, and a stale value cannot outlive
// the browser session. Switching to a non developer tenant corrects it anyway, because
// sugar then reports false.

const KEY = 'developerMode';

const parse = (raw) => {
    if (raw === 'true' || raw === '1') {
        return true;
    }
    if (raw === 'false' || raw === '0') {
        return false;
    }
    return null;
}

/**
 * The last known developer mode setting, or null when nothing has been stored yet.
 *
 * @returns {boolean|null}
 */
export const readStoredDeveloperMode = () => {
    try {
        return parse(window.sessionStorage.getItem(KEY));
    } catch (e) {
        return null;
    }
}

/**
 * The setting to render with before sugar has had a chance to report anything.
 *
 * @returns {boolean}
 */
export const resolveInitialDeveloperMode = () => readStoredDeveloperMode() === true;

/**
 * Remember the developer mode setting.
 *
 * @param {boolean} value
 */
export const writeDeveloperMode = (value) => {
    try {
        window.sessionStorage.setItem(KEY, value ? 'true' : 'false');
    } catch (e) {
        // ignore
    }
}
